export default {
  navigaLink(evt) {
    evt.preventDefault();
    let { target } = evt;
    while (target != null && target.tagName.toLowerCase() != 'a') {
      target = target.parentElement;
    }

    if (target == null) {
      return;
    }

    const href = target.getAttribute('href');
    if (href == false) {
      return;
    }

    if (href.indexOf('http') != -1) {
      window.open(href, '_blank');
    } else {
      window.open(`http://${href}`, '_blank');
    }
  },
};

export function getQueryParams(search) {
  return new URLSearchParams(search);
}

export function requestFocus(reference) {
  setTimeout(() => {
    reference.current && reference.current.focus();
  }, 300);
}

export function normalizeUrl(urlSource) {
  if (urlSource.endsWith('/')) {
    return urlSource.substring(0, urlSource.length - 1);
  }
  return urlSource;
}
